import React from "react";
import * as Theme from "../../../styles";


export const SpendPartnerLink = ({ url }) => (
  <Theme.SpendPartnerLink href={url}>Website Link</Theme.SpendPartnerLink>
);
